var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-input",class:{'w-100': !_vm.classList}},[_c('vue-timepicker',{class:_vm.classList || 'w-100',attrs:{"format":"HH:mm:ss","hide-clear-button":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }